// Tab tables for SettingsTabsV2026. Each rail must read character-for-character the same as its
// page's flag-OFF b-nav, down to the leading space in ' (Sales)' / ' (Recruit)' / ' (Mari)'.
// RAIL_LABELS is not imported on purpose — it says 'คุณลูกค้า…' where these pages say 'คีย์ลัดฝั่ง…'.
const ICONS = {
  messageUser: require('@/assets/icons2026/message-user.svg'),
  aiUser: require('@/assets/icons2026/ai-user.svg'),
  userGroup: require('@/assets/icons2026/user-group.svg')
}

const BASE = {
  customer: { label: 'คุณลูกค้า', icon: ICONS.messageUser },
  professional: { label: 'ผู้สมัคร', icon: ICONS.userGroup },
  professional_secondary: { label: 'ผู้สมัคร (สำรอง)', icon: ICONS.userGroup },
  beneat_professional: { label: 'คุณแม่บ้าน', icon: ICONS.aiUser },
  sales_product_customer: { label: 'คุณลูกค้า (Sales)', icon: ICONS.messageUser },
  recruitment_customer: { label: 'คุณลูกค้า (Recruit)', icon: ICONS.messageUser },
  recruitment_professional: { label: 'คุณแม่บ้าน (Recruit)', icon: ICONS.aiUser },
  mari_customer: { label: 'คุณลูกค้า (Mari)', icon: ICONS.messageUser },
  mari_professional: { label: 'ผู้สมัคร (Mari)', icon: ICONS.userGroup }
}

// AutoMessage also offers professional_secondary, which is why the order lives here, not in BASE.
const EIGHT = [
  'customer',
  'professional',
  'beneat_professional',
  'sales_product_customer',
  'recruitment_customer',
  'recruitment_professional',
  'mari_customer',
  'mari_professional'
]

const buildTabs = (prefix, types) => types.map(type => ({
  type,
  label: prefix + BASE[type].label,
  icon: BASE[type].icon
}))

export const MT_TABS = buildTabs('คีย์ลัดฝั่ง', EIGHT)

// Also feeds TagFormModalV2026's กลุ่มของแท็ก select, so rail and dialog name the groups alike.
export const TAG_TABS = buildTabs('แท็กฝั่ง', EIGHT)

// AutoMessage's b-nav has no prefix ('คุณลูกค้า', not 'คีย์ลัดฝั่งคุณลูกค้า') and includes
// professional_secondary as its own tab — it fetches the professional record underneath.
const AM_TYPES = [
  'customer',
  'professional',
  'professional_secondary',
  'beneat_professional',
  'sales_product_customer',
  'recruitment_customer',
  'recruitment_professional',
  'mari_customer',
  'mari_professional'
]

export const AM_TABS = AM_TYPES.map(type => ({
  type,
  label: BASE[type].label,
  icon: BASE[type].icon
}))
